import TitleElementMetaData from './TitleElementMetaData';

const presets = [
  {
    type: TitleElementMetaData.type,
    layout: {
      x: 0,
      y: 0,
      width: 500,
      height: 43
    },
    compProps: {
      zIndex: 1
    },
    data: {
      text: 'I\'m a title. Double click me to edit.',
      compProps: {
        color: 'rgb(83, 83, 83)',
        fontSize: '32px',
        fontStyle: 'normal',
        textAlign: 'center',
        textDecoration: 'none',
        fontFamily: 'Roboto',
      },
    },
    hidden: false
  }
];
export default presets;
